import { navigateToHeritageFunnel } from "@/helpers/heritage-integration/navigation-helper";

export async function heritageBeforeEnter(to, from) {
    await navigateToHeritageFunnel({ shouldSaveSession: false, pageNameToLog: to.name });
}
